import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { GiftOrderDetailResponse } from '@models/gift';
import { GiftCouponStatusKr } from '@models/gift/extension';
import dayjs from 'dayjs';

interface Props {
    giftOrder: GiftOrderDetailResponse;
}

function GiftOrderInfo({ giftOrder }:Props) {
  const { detail, payment, count } = giftOrder;

  const receiverNames = detail.receiverNames.join(',');
  const { giftCoupon, giftItem } = detail;
  const { imageUrl, name, giftItemType } = giftItem;
  return (
        <Column as='section'
                fullWidth
                align='center'
                spacing={42} >
            <Column align='center' spacing={14}>
                {giftItemType === 'CASH' ? (
                    <CardImage src={imageUrl}
                           width={200}
                           height={134} />
                ) : (
                    <ImageWrapper>
                        <Image src={imageUrl}
                               width={72}
                               height={72} />
                    </ImageWrapper>
                )}
                <Column align='center'>
                    <Text size='lg' fontWeight='bold'>{name}</Text>
                    <Row spacing={8} align='center'>
                        <Text color={colors.gray8}>{count}개</Text>
                        <Text color={colors.primary}
                              fontWeight='bold'
                              size='lg' >
                            {payment.amount.toLocaleString()}원
                        </Text>
                    </Row>
                </Column>
            </Column>
            <Column fullWidth align='center'>
                <InfoCard>
                    <Text color={colors.gray6}>받는 사람</Text>
                    <Text color={colors.gray7} fontWeight='bold' align='right'>
                        {receiverNames}
                    </Text>
                    <Text color={colors.gray6}>유효기간</Text>
                    <Text color={colors.gray7} fontWeight='bold' align='right'>
                        {dayjs(giftCoupon?.startAt).format('YYYY.MM.DD')} ~ {dayjs(giftCoupon?.expiredAt).format('YYYY.MM.DD')}
                    </Text>
                    <Text color={colors.gray6}>쿠폰 상태</Text>
                    <Text color={colors.gray7} fontWeight='bold' align='right'>
                        {GiftCouponStatusKr[giftCoupon?.status || 'SEND_FAILED']}
                    </Text>
                    <Text color={colors.gray6}>결제수단</Text>
                    <Text color={colors.gray7} fontWeight='bold' align='right'>
                        {payment.paymentMethod === 'CREDIT_CARD' ? '신용카드' : '선불카드'}
                    </Text>
                    <Text color={colors.gray6}>결제금액</Text>
                    <Text color={colors.red} fontWeight='bold' align='right'>
                        {payment.amount.toLocaleString()}원
                    </Text>
                </InfoCard>
            </Column>

        </Column>
  );
}

const ImageWrapper = styled.div`
    background-color: ${colors.white};
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.14);
    border-radius: 12px;
    width: 100px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const InfoCard = styled.div`
    padding: 12px;
    background-color: ${colors.gray1};
    width: calc(100% - 40px);
    border-radius: 8px;
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 6px;
`;

const CardImage = styled(Image)`
    object-fit: cover;
    border-radius: 8px;
`;

export default GiftOrderInfo;
